import { storyblokEditable } from '@storyblok/react/rsc'
import { clsx } from 'clsx'
import { type FC } from 'react'

import { useBlockStyle } from '@redteclab/storyblok-style-field-plugin'

import { type StoryblokComponentProps } from '../../model'
import { type StoryblokTextCardType } from '../../storyblok'
import { StoryblokComponentsRenderer } from '../StoryblokComponentsRenderer'

export const StoryblokTextCard: FC<
  StoryblokComponentProps<StoryblokTextCardType>
> = ({ blok }) => {
  const { content, style } = blok

  const { blockClassName, blockStyle } = useBlockStyle(style)

  return (
    <div
      {...storyblokEditable(blok)}
      className={clsx(blockClassName, 'p-4', 'rounded-2xl')}
      style={blockStyle}
    >
      <StoryblokComponentsRenderer bloks={content} />
    </div>
  )
}
